import { EventEmitter, Injectable } from '@angular/core';
import { EnvironmentLoaderService } from './BackEndURL/environment-loader.service';
import { SecurityService } from './security.service';

@Injectable({ providedIn: 'root' })
export class SharedService {

  closeDialog = new EventEmitter<any>();
  TitleChanged = new EventEmitter<any>();
  KittingSettingsChanged = new EventEmitter<any>();
  PackSettingsChanged = new EventEmitter<any>();
  ShipSettingsChanged = new EventEmitter<any>();
  FundingSourceSettingsChanged = new EventEmitter<any>();
  model: any = {};
  submodel: any = {};

  openDialog = new EventEmitter<any>();

  batchStocks: any = {};
  batchInventories: any = {};

  packSettings = new EventEmitter<boolean>();
  shipkSettings = new EventEmitter<boolean>();
  assetsPrintreceiptkSettings = new EventEmitter<boolean>();
  stockPrintreceiptkSettings = new EventEmitter<boolean>();
  StockTransactionDateEditingkSettings = new EventEmitter<boolean>();
  AssetsTransactionDateEditingkSettings = new EventEmitter<boolean>();

  inventoryAlertSettings = new EventEmitter<boolean>();

  okCloseClicked = new EventEmitter<boolean>();
  pendingNote: string = '';
  ActivateOrDeactivate: EventEmitter<any> = new EventEmitter();

  //#region  Output For Layout after delete from grid
  onDeleteFromGrid: EventEmitter<boolean> = new EventEmitter();

  formDeactivated: any;
  base: string;
  commonModulesHasStockController = ['vendors', 'categories', 'disposeTo', 'categories', 'locations', 'locationTypes', 'addresses', 'users'];
  ImageUrl(input: string) {
    return EnvironmentLoaderService.envConfig.enterpriseApiLocal + '/' + input;
  }


  constructor(private _securityService: SecurityService) { }

  getUserTimezoneOffset(): number {
    const userTimezone = this._securityService.currentUser?.timezone;
    if (userTimezone && userTimezone.ref) {
      const parsed = parseFloat(userTimezone.ref);
      if (!isNaN(parsed)) {
        return parsed;
      }
    }
    return -new Date().getTimezoneOffset();
  }

  getTodayInUserTimezone(): Date {
    const now = new Date();
    const utcTime = now.getTime() + now.getTimezoneOffset() * 60000;
    const userOffset = this.getUserTimezoneOffset();
    const userTimeMillis = utcTime + (userOffset * 60000);
    const userDateUtc = new Date(userTimeMillis);
    return new Date(
      userDateUtc.getUTCFullYear(),
      userDateUtc.getUTCMonth(),
      userDateUtc.getUTCDate(),
      userDateUtc.getUTCHours(),
      userDateUtc.getUTCMinutes(),
      userDateUtc.getUTCSeconds()
    );
  }

  setPageSize(userId: string, pageName: string, size: string): void {

    const raw = localStorage.getItem('userPreferences');
    const prefs = raw ? JSON.parse(raw) : { userPreferences: [] };

    let userEntry = prefs.userPreferences.find((entry: any) => entry[userId]);

    if (!userEntry) {
      userEntry = { [userId]: [] };
      prefs.userPreferences.push(userEntry);
    }

    let pageEntry = userEntry[userId].find((entry: any) => entry[pageName]);
    if (!pageEntry) {
      userEntry[userId].push({ [pageName]: { size } });
    } else {
      pageEntry[pageName].size = size;
    }

    localStorage.setItem('userPreferences', JSON.stringify(prefs));
  }

  getPageSize(userId: string, pageName: string): string | null {

    const raw = localStorage.getItem('userPreferences');

    if (!raw) return null;

    const prefs = JSON.parse(raw);
    const userEntry = prefs.userPreferences.find((entry: any) => entry[userId]);

    if (!userEntry) return null;

    const pageEntry = userEntry[userId].find((entry: any) => entry[pageName]);

    return pageEntry ? pageEntry[pageName].size : null;
  }
}
